import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const linkGroups = [
    {
      title: "剧集分类",
      links: [
        { to: "/category/synopsis", label: "剧情介绍" },
        { to: "/category/cast", label: "主演信息" },
        { to: "/category/updates", label: "剧集更新" },
      ],
    },
    {
      title: "快捷入口",
      links: [
        { to: "/", label: "首页" },
        { to: "/search", label: "站内搜索" },
        { to: "/about", label: "关于本站" },
      ],
    },
  ];

  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="w-full px-4 py-12 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-movie-2-line text-lg leading-none"></i>
              </span>
              <span className="font-heading text-lg font-bold">{siteInfo.brand}</span>
            </div>
            <p className="mt-4 max-w-md font-label text-sm leading-relaxed text-background-300">
              {siteInfo.intro2}
            </p>
            <p className="mt-4 font-label text-xs leading-relaxed text-background-400">
              {siteInfo.icp}
            </p>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
                {group.title}
              </h4>
              <ul className="mt-4 flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="font-label text-sm text-background-300 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-700/60 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-400">
            © {new Date().getFullYear()} {siteInfo.brand}影视内容站 · 仅供资料查阅与演示
          </p>
          <p className="flex items-center gap-2 font-label text-xs text-background-400">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-line text-sm leading-none"></i>
            </span>
            {siteInfo.email}
          </p>
        </div>
      </div>
    </footer>
  );
}